import React from 'react';
import { useTranslation } from './utils/locales/useTranslation';
import { sourceKey } from './utils/locales/config';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent />;
    }

    return this.props.children;
  }
}

// Functional component to use hooks for translation
const ErrorComponent = () => {
  const { t } = useTranslation();

  return <p>{t("loadingFailedPleaseReload", sourceKey.product)}</p>;
};

export default ErrorBoundary;